import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\">\r\n<rect x=\"5\" y=\"5\" width=\"8\" height=\"22\" rx=\"3\" fill=\"#1CA59D\" />\r\n<rect x=\"18\" y=\"5\" width=\"8\" height=\"22\" rx=\"3\" fill=\"#1CA59D\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol